export default __webpack_public_path__ + "static/media/cvod-RP16.ce9687e2.svg";